import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

import MetaTags from "../../components/Common/MetaTags";
import Headline from "../../components/Common/Headline";
import PostList from "../../components/Blog/PostList";
import { getDocuments } from "../../services/contentHelpers";

export default function Ressources({ posts }) {
  const { t } = useTranslation(["ebooks-webinars", "common"]);

  return (
    <>
      <MetaTags scope="ebooks-webinars" />

      <Headline title1={t("hero.title")}>
        <PostList posts={posts} />
      </Headline>
    </>
  );
}

export async function getStaticProps({ locale }) {
  const posts = getDocuments("ebooks-webinars", locale);

  return {
    props: {
      ...(await serverSideTranslations(locale, ["common", "ebooks-webinars"])),
      posts,
    },
  };
}
